import { AppState } from '..'

export const selectActiveInvestment = (state: AppState) => state.betslip.workflow.activeInvestment

export const selectKeypadActiveValue = (state: AppState) => state.betslip.workflow.keypadActiveValue
